import { request } from "./api";

export function getMatch(data) {
  const url = `/player/game-list/${data}`;
  return request("get", url, {});
}
